const CARES_AUTHENTICATED_PREFIXES = [
  '/admin',
  '/clients',
  '/my-schedule',
  '/scheduling',
  '/scheduler-review',
  '/schedule-settings',
  '/admin-settings',
  '/faq',
  '/user-settings',
];

const CARES_AUTHENTICATED_EXACT_PATHS = new Set([
  '/pages/notification',
  '/user-profile',
]);

const CARES_AUTHENTICATED_LEGACY_PREFIXES = [
  '/app/admin',
  '/app/clients',
  '/app/my-schedule',
  '/app/scheduling',
  '/app/scheduler-review',
  '/app/schedule-settings',
  '/app/admin-settings',
  '/app/faq',
  '/app/user-settings',
];

export const isCaresOwnedAuthenticatedPath = (pathname: string) => {
  if (CARES_AUTHENTICATED_EXACT_PATHS.has(pathname)) {
    return true;
  }

  return [...CARES_AUTHENTICATED_PREFIXES, ...CARES_AUTHENTICATED_LEGACY_PREFIXES].some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
};
